import { Typography, TableRow, TableCell, Button, Table, TableHead } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { withStyles } from '@material-ui/styles';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import UploadCsv from '../../../../../components/UploadCsv/UploadCsv';
import GeracaoDistribuidaTable from '../GeracaoDistribuidaTable/GeracaoDistribuidaTable';
import styles from './GeracaoDistribuidaParametros.style';
import { useGeracaoDistribuida } from '../../GeracaoDistribuidaProvider';
import { usePermissions } from '../../../../../hooks/usePermissions/usePermissions';

function GeracaoDistribuidaParametros() {
  const [openModal, setOpenModal] = useState(false);
  const { getPermissions } = usePermissions();
  const editar = getPermissions();

  const { parametrosGD, error, isFetching, refetchGeracaoDistribuida } = useGeracaoDistribuida();

  if (error) {
    return <Typography variant="h6">{error}</Typography>;
  }
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={370}>
              <Typography variant="h6">Geração Distribuida - Parâmetros</Typography>
            </TableCell>
            <TableCell align="left">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                startIcon={<CloudUploadIcon />}
                onClick={() => setOpenModal(true)}
                disabled={!editar}
              >
                Enviar CSV
              </Button>
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>

      {!isFetching && !isEmpty(parametrosGD) && <GeracaoDistribuidaTable parametrosGD={parametrosGD} />}

      <UploadCsv
        config={{
          url: '/importacao-geracao-distribuida/parametros',
          alert: {
            init: 'Enviando CSV de Parâmetros de Geração Distribuída',
            error: 'Não foi possível enviar o CSV de Parâmetros de Geração Distribuída',
            success: 'CSV de Parâmetros de Geração Distribuída enviado com sucesso!',
          },
          queryCacheId: 'fetch-parametro-distribuidora-migracao',
          dialog: {
            title: 'Enviar CSV de Parâmetros de Geração Distribuída',
          },
          updatePage: refetchGeracaoDistribuida,
        }}
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
}

export default withStyles(styles)(GeracaoDistribuidaParametros);
